import {notificationsStoreInstanceRef} from '@components/common/base/notifications/show-confirm'

export interface ShowConfirmProps {
  message: string
  isDanger?: boolean
}

export const sharedShowConfirm = (title: string, config?: ShowConfirmProps) => {
  const notificationsStore = notificationsStoreInstanceRef.current
  if (!notificationsStore) {
    return Promise.resolve(false)
  }

  return notificationsStore.showConfirm({
    title,
    subtitle: config?.message,
    dialogProps: {
      isDelete: config?.isDanger
    }
  })
}
